// extracted by mini-css-extract-plugin
export default {"successWrap":"styles_successWrap__JCyK0","successTitle":"styles_successTitle__NrR5R","successForm":"styles_successForm__2MOfi","successImg":"styles_successImg__VA7Ml"};